const componentForm = {
    /**Numero civico */
    street_number: 'short_name',
    /**Strada */
    route: 'long_name',
    /**Comune */
    administrative_area_level_3: 'long_name',
    /**Provincia */
    administrative_area_level_2: 'short_name',
    /**Codice postal */
    postal_code: 'short_name'
};

const formToStateMap = {
    street_number: 'addressNumber',
    route: 'address',
    administrative_area_level_3: 'municipality',
    administrative_area_level_2: 'province',
    postal_code: 'postalCode'
}

export const googleAutocompleteAddress = (ref, foundCallback = () => {}, callback = () => {}) => {
    console.log('Google autocomplete address creation');
    
    const createGoogleAutoComplete = () => {
        const autocomplete = new window.google.maps.places.Autocomplete(
            ref.current, { types: ['address'] ,componentRestrictions: { country: 'it' } }
        );
    
        autocomplete.setFields(['address_component']);
    
        autocomplete.addListener('place_changed', () => {
            console.log('Google input pressed');
            foundCallback();
            const place = autocomplete.getPlace();
            console.log(place);
            const result = {};
            if (!place.address_components) return;
            for (let i = 0; i < place.address_components.length; i++) {
                // AddressType contiene le chiavi di componentForm
                const addressType = place.address_components[i].types[0];
                if (componentForm[addressType]) {
                    result[formToStateMap[addressType]] = place.address_components[i][componentForm[addressType]];
                }
            }
            console.log(result);
            callback(result);
        });
    }

    if (!window.google) {
        console.log('Google was not initialized');
        let current = 0;
        const interval = setInterval(() => {
            console.log("Attempting to load google");
            if (window.google) {
                console.log('Google loaded')
                clearInterval(interval);
                createGoogleAutoComplete();
            } else {
                // console.log('Google not yet loaded');
            }

            current += 1;
            if (current > 40) {
                console.log('Maximum timeout reached');
                clearInterval(interval);
            }
        }, 100);
    } else {
        console.log("Google was loaded");
        createGoogleAutoComplete();
    }
}